import React from "react";
import styled from "styled-components/macro";

import { MainContext } from "../App.js";

const footer = () => {
  return (
    <DeskPadder>
      <div>
        {localStorage.getItem("Country") === "USA" && (
          <p>
            &copy; {new Date().getFullYear()} Wiha Tools USA. All Rights
            Reserved.
          </p>
        )}
        {localStorage.getItem("Country") === "Canada" && (
          <p>
            &copy; {new Date().getFullYear()} Wiha Tools Canada. All Rights
            Reserved.
          </p>
        )}
        <span>
          <MainContext.Consumer>
            {context => (
              <p>
                {" "}
                {/* eslint-disable-next-line */}
                <a href="#" onClick={context.flipTheSwitch}>
                  Change Country
                </a>
              </p>
            )}
          </MainContext.Consumer>

          {localStorage.getItem("Country") === "Canada" && (
            <p>
              <a href="mailto:info@wihatools.ca">Support</a>
            </p>
          )}
          {localStorage.getItem("Country") === "USA" && (
            <p>
              <a href="mailto:cservice@wihatools.com">Support</a>
            </p>
          )}
        </span>
      </div>
    </DeskPadder>
  );
};

export default footer;

const DeskPadder = styled.div`
  background: #000000;
  overflow: hidden;
  width: 100%;
  padding-bottom: 5rem;

  div {
    color: #999999;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 57rem;

    span {
      display: block;
      display: flex;
      justify-content: flex-end;
      width: 60%;
    }

    a {
      color: #ffffff;
      margin: 0 10px;
      cursor: pointer;
    }
  }

  @media (max-width: 57rem) {
    background: transparent;
    width: 100%;
    position: inherit;
    text-align: center;
    div {
      width: 100%;
      flex-direction: column;
      span {
        justify-content: center;
      }
      a {
        color: inherit;
        text-decoration: underline;
      }
    }
  }
`;
